import { type ReactNode } from 'react';
import { Sparkles } from 'lucide-react';
import { cn } from 'utils/className';

type BillingStatusChipProps = {
  colorClass: string;
  propsClassName?: string;
  children: ReactNode;
};

/** Shared "[Sparkles] status text" chip — Sparkles icon + mono uppercase label. */
export const BillingStatusChip = ({
  colorClass,
  propsClassName,
  children,
}: BillingStatusChipProps) => {
  const className = cn(
    'flex items-center gap-1.5 font-mono text-xs font-normal uppercase',
    colorClass,
    propsClassName,
  );

  return (
    <span className={className}>
      <Sparkles className={cn('size-3.5', colorClass)} />
      {children}
    </span>
  );
};
